export function ImprovementsReportPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">Sobre los informes de asesoramiento personalizado</h1>
    <p class="hero-subtitle">Descubra qué incluye nuestro informe y cómo puede ayudarle a ahorrar</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="max-w-6xl mx-auto prose prose-lg">
      <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

        <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">

          <h2 class="text-2xl text-blue-900 mb-4">Mejore el rendimiento energético de su vivienda o edificio en España</h2>

          <p>¿Quiere mejorar el rendimiento energético (EP) de su vivienda o local comercial en España? ¿Le gustaría saber qué medidas encajan en su situación y qué rendimiento pueden ofrecer? ¡Solicite entonces un asesoramiento personalizado a través de uno de los asesores energéticos acreditados de CEEcasasespaña.com!</p>

          <p>Uno de nuestros asesores certificados le visitará en España para elaborar un informe de recomendaciones personalizado. Obtendrá información clara sobre las mejoras constructivas y de instalaciones que harán su vivienda más eficiente, confortable y saludable, y mejor adaptada al clima cálido español. El informe contiene un resumen claro de las mejores medidas para su caso, incluyendo costes y tiempos de amortización.</p>

          <p class="mt-2 font-medium flex items-center gap-2">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
            <span>¿Quiere saber más? A continuación explicamos todo sobre los informes de asesoramiento para viviendas y edificios comerciales en España.</span>
          </p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">¿Qué es un asesoramiento personalizado?</h3>
          <p>Un asesoramiento personalizado es un plan de mejora energética detallado elaborado por un asesor energético acreditado. Durante la inspección, el asesor evalúa tanto el estado constructivo como las instalaciones (como aire acondicionado, calderas, calefacción y ventilación).</p>

          <p>Basándose en ello, recibirá un informe con recomendaciones concretas, como:</p>
          <ul>
            <li>aislamiento de fachada, cubierta y suelo (también importante para la protección frente al calor);</li>
            <li>mejoras de ventilación y sistemas de sombreado para un clima interior más saludable;</li>
            <li>optimización o sustitución de sistemas de aire acondicionado o bombas de calor;</li>
            <li>y la aplicación de paneles solares o termosifones para energía renovable.</li>
          </ul>

          <p>El asesoramiento sigue el principio de la Trias Energética:</p>
          <ul>
            <li>Reducir el consumo energético – por ejemplo con aislamiento o protección solar.</li>
            <li>Utilizar energía sostenible – como una bomba de calor o un termosifón solar.</li>
            <li>Generar energía renovable – por ejemplo con paneles solares.</li>
          </ul>

          <p>El asesoramiento personalizado se combina siempre con un Certificado de Eficiencia Energética de España. Este certificado muestra la situación energética actual (la medición inicial), mientras que el asesoramiento muestra cómo mejorarla.</p>

          <p class="mt-2 font-medium">💡 Atención: también en España se aplica la regla — primero aislar, y solo después invertir en paneles solares o bombas de calor. Sin un buen aislamiento, gran parte de la energía se pierde y el rendimiento es bajo.</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">¿Qué aporta un asesoramiento personalizado?</h3>
          <p>Un asesoramiento personalizado le ofrece una visión clara de:</p>
          <ul>
            <li>las medidas recomendadas, con costes y tiempos de amortización;</li>
            <li>cuáles medidas son más rentables en el clima español;</li>
            <li>la mejora prevista de su certificado energético;</li>
            <li>y los efectos sobre el confort interior, la regulación térmica y el control de la humedad.</li>
          </ul>

          <p>Además, este tipo de informe suele ser aceptado por bancos en solicitudes de hipotecas verdes o préstamos para rehabilitación energética. Así sabrá exactamente qué es posible y qué inversión se requiere.</p>

          <p>Nuestros asesores son completamente independientes y no están vinculados a proveedores ni instaladores. Usted decide con qué empresa local quiere ejecutar las medidas recomendadas.</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">¿Cómo solicitar un asesoramiento personalizado?</h3>
          <p>¿Desea saber cuán eficiente es su vivienda o edificio en España? A través de nuestro comparador puede solicitar fácilmente un asesoramiento personalizado seleccionando la opción “Certificado Energético + Asesoramiento Personalizado”.</p>

          <p>El certificado energético es el punto de partida (la medición inicial). Mientras que el certificado normalmente es el punto final, en un asesoramiento personalizado es justamente el inicio de la mejora.</p>

          <p class="mt-2 font-medium">📍 ¡Solicite aquí su asesoramiento personalizado para España!</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">Preguntas frecuentes sobre asesoramientos personalizados</h3>
          <p>¿Tiene dudas sobre los asesoramientos personalizados en España? Consulte nuestro resumen con las preguntas más frecuentes. ¿Aún necesita ayuda?</p>

          <p class="mt-2">Póngase en contacto con nuestro equipo:<br>📧 info@CEEcasasespaña.com</p>

        </div>

        <div class="p-8 rounded-lg shadow-sm md:w-1/3" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
          <img src="/images/team/compare.webp" alt="Compare asesores de certificados energéticos" class="mb-4 w-full h-auto rounded-md object-cover" />
          <p class="mb-4">Compare asesores de certificados energéticos.
Compare precios, calidad y rapidez según sus datos.</p>

          <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Comparar ahora -></a></p>
        </div>

      </div>
    </div>
  </div>
</section>
      
<section class="section bg-blue-600 text-white">
  <div class="container text-center">
    <h2 class="text-3xl font-bold mb-4">¿Desea recibir su informe personalizado?</h2>
    <p class="text-xl mb-8 opacity-90">Obtenga recomendaciones específicas para su vivienda y descubra cuánto puede ahorrar</p>
    <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/contact/">Solicitar Certificado CEE</button>
  </div>
</section>

  `;
}
